import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class MobileAppPopupAnalytics extends BaseAnalytics {
    constructor(category = 'VAS') {
        super();

        this.category = category;
    }

    show() {
        this.send('view_install_app_after_payment');
    }

    downloadApp() {
        this.send('click_download_app');
    }
}

export const mobileAppPopupAnalytics = new MobileAppPopupAnalytics();
